/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-02-13 09:39:25
 * @LastEditors: linxi
 * @LastEditTime: 2025-02-13 14:06:11
 */
import { API_PREFIX } from './constant'
import { Request } from './request'

export interface AIListParams {
  startTime?: any
  endTime?: any
  current?: any
  size?: any
}

export function AIList(params: AIListParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/sysairecord/page`,
    method: 'GET',
    params,
  }
}

export interface AIRecordDetailParams {
  id?:number
}
export function AIRecordDetail(params: AIDetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/sysairecord/detail`,
    method: 'GET',
    params,
  }
}
export function AIDetail(): Request {
  return {
    url: `${API_PREFIX}/blade-administer/sysaimodel/detail`,
    method: 'GET',
  }
}

export interface AIDetailParams {
  basePlat?: any
  modelVersion?: any
  modelUrl?: any
  auth?: any
  temperature?: any
  frequencyPenalty?: any
  presencePenalty?: any
  id?: any
}

export function AIDetailSubmit(body: AIDetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/sysaimodel/update`,
    method: 'POST',
    body,
  }
}
